// Reference: https://gist.github.com/bradtraversy/1c93938c1fe4f10d1e5b0532ae22e16a
import '../tailwind.css';
// Import our custom CSS
import '../scss/theme.scss'

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import '@glidejs/glide/dist/css/glide.core.min.css';
import '@glidejs/glide/dist/glide.min.js';


function newCustomNavigation() {
    document.addEventListener("DOMContentLoaded", () => {
        const mainNav = document.querySelector('.hst-menu');

        if (!mainNav) {
            console.error("Main navigation element not found!");
            return;
        }

        const menuItems = document.querySelectorAll('.menu-item.menu-item-has-children');

        menuItems.forEach((item) => {
            const subMenu = item.querySelector('.sub-menu');
            const navLink = item.querySelector('a');

            const toggle = document.createElement("span");
            toggle.innerHTML = `
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="w-4 h-4 default-svg">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
                </svg>
            `;
            toggle.classList.add('menu-toggle'); 
            navLink.appendChild(toggle); 

            const toggleDropdown = (e) => {
                e.preventDefault();
                subMenu.classList.toggle('max-h-screen');
                subMenu.classList.toggle('opacity-100');
            };

            navLink.addEventListener('click', (e) => {
                if (subMenu) {
                    toggleDropdown(e);
                }
                toggle.classList.toggle('is-clicked');

                // Gestione alternanza SVG
                const isDefault = toggle.querySelector('svg.default-svg');
                toggle.innerHTML = isDefault ? `
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="w-4 h-4 alternative-svg">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M5 12h14" />
                    </svg>
                ` : `
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="w-4 h-4 default-svg">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
                    </svg>
                `;
            });
        });
    });
}
newCustomNavigation();




function offCanvas(){
    const triggers = document.querySelectorAll(".js--offCanvas");
    triggers.forEach( trigger => {
        trigger.addEventListener('click', (e) => {
            const target = e.currentTarget;
            const data = target.getAttribute("data-target");
            const canvas = document.getElementById(data);

            if (canvas.classList.contains('translate-x-full')) {
                canvas.classList.remove('translate-x-full');
                canvas.classList.add('translate-x-0');
            } else if(canvas.classList.contains('translate-x-0')){
                canvas.classList.add('translate-x-0');
                canvas.classList.remove('translate-x-full');
            }
            
            console.log(canvas);
        })
    });
}offCanvas();


/*
document.querySelectorAll('a[href^="#"]').forEach(navLinks => {
    navLinks.addEventListener('click', function(e) {
        e.preventDefault();
        const targetId = this.getAttribute('href');
        const targetElement = document.querySelector(targetId);

        if (targetElement) {
            targetElement.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }
    });
});
*/

document.addEventListener("DOMContentLoaded", function () {
    const panels = document.querySelectorAll(".accordion-panel");
    const nestedPanels = document.querySelectorAll(".nested-accordion-panel");

    document.addEventListener("click", (event) => {
        const mainHeading = event.target.closest(".js--accordion-heading");
        const nestedHeading = event.target.closest(".js--nested-accordion-heading");

        if (mainHeading) {
            const index = [...document.querySelectorAll(".js--accordion-heading")].indexOf(mainHeading);
            openAccordion(panels, index);
        }

        if (nestedHeading) {
            const index = [...document.querySelectorAll(".js--nested-accordion-heading")].indexOf(nestedHeading);
            openAccordion(nestedPanels, index);
        }
    });

    function openAccordion(panelList, index) {
        panelList.forEach((panel, i) => {
            const isOpen = panel.classList.contains("open");

            if (i === index) {
                panel.classList.toggle("open", !isOpen);
                toggleAriaAttributes(panel, !isOpen);
            } else {
                panel.classList.remove("open");
                toggleAriaAttributes(panel, false);
            }
        });
    }

    function toggleAriaAttributes(panel, isOpen) {
        const heading = panel.previousElementSibling;
        if (heading) {
            heading.setAttribute("aria-expanded", isOpen);
        }
        panel.setAttribute("aria-hidden", !isOpen);
    }
});




function gsapAnimation(){

    gsap.registerPlugin(ScrollTrigger);

    ScrollTrigger.batch(".gs--fadeInFromUp", {
        start: "top 90%",
        onEnter: (elements, triggers) => {
            gsap.to(elements, {opacity: 1, stagger: 0.25, y: 0, duration: 1 });
        },
    });

    ScrollTrigger.batch(".gs--fadeInFromDown", {
        start: "top 90%",
        onEnter: (elements, triggers) => {
            gsap.to(elements, {opacity: 1, stagger: 0.25, y: 0, duration: 1 });
        },
    });


    ScrollTrigger.batch(".gs--fadeInFromRight", {
        start: "top 90%",
        onEnter: (elements, triggers) => {
            gsap.to(elements, {opacity: 1, stagger: 0.25, x: 0, duration: 1 });
        },
    });

    ScrollTrigger.batch(".gs--fadeInFromLeft", {
        start: "top 90%",
        onEnter: (elements, triggers) => {
            gsap.to(elements, {opacity: 1, stagger: 0.25, x: 0, duration: 1 });
        },
    });

    ScrollTrigger.batch(".gs--fadeInDiagonalFromLeft", {
        start: "top 90%",
        onEnter: (elements, triggers) => {
            gsap.to(elements, {opacity: 1, stagger: 0.25, x: 0, y: 0, duration: 1 });
        },
    });

    ScrollTrigger.batch(".gs--fadeInDiagonalFromRight", {
        start: "top 90%",
        onEnter: (elements, triggers) => {
            gsap.to(elements, {opacity: 1, stagger: 0.25, x: 0, y: 0, duration: 1 });
        },
    });
    

    ScrollTrigger.batch(".gs--maskUp", {
        start: "top 90%",
        onEnter: (elements, triggers) => {
            gsap.to(elements, {clipPath: "polygon(0 0, 100% 0, 100% 100%, 0% 100%)", y: 0, duration: 1.5, scrub: true });
        },
    });

    ScrollTrigger.batch(".gs--fadeInToOpacity", {
        start: "top 70%",
        onEnter: (elements, triggers) => {
            gsap.to(elements, {opacity: 1, duration: 0.5, y: 0, scrub: true });
        },
    });
}
gsapAnimation();


function caroselloServizi() {
    document.addEventListener('DOMContentLoaded', () => {
        new Glide('.glide.glide--settori',{
            type: 'carousel',
            startAt: 0,
            perView: 3,
            gap: 32,
            autoplay: 3000,
            breakpoints: {
                576: {
                    perView: 1.25
                },
                991: {
                    perView: 2
                }
            }
        }).mount()
        
    });
}
caroselloServizi();